import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Icon,
  Slide
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import PictureAsPdfSharpIcon from '@material-ui/icons/PictureAsPdfSharp';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DialogCreateAgreementPdf = (props) => {
  return (
    <Dialog
      aria-labelledby="approval-required-title"
      aria-describedby="approval-required-description"
      open={props.open}
      onClose={props.onClose}
      TransitionComponent={Transition}
      className="dialog-wrapper"
    >
      <DialogTitle id="approval-required-title" className="dialog-title">
        {props.intl.formatMessage({
          id: 'generate_proposal_subheader'
        })}{' '}
      </DialogTitle>
      <DialogContent>
        <p id="approval-required-description" className="dialog-text">
          {props.intl.formatMessage({
            id: 'create_agreement_pdf_dialog'
          })}{' '}
        </p>
        <hr />
      </DialogContent>
      <DialogActions className="dialog-action-buttons">
        <span className="btn-secondary-action">
          <Button onClick={props.onClose} color="primary">
            {' '}
            {props.intl.formatMessage({
              id: 'cancel'
            })}
          </Button>
        </span>
        {!props.hideAccept ? (
          <span className="btn-action">
            <Button onClick={props.onAccept} color="primary">
              {props.intl.formatMessage({
                id: 'yes_create_editable_document'
              })}

              {/*<PictureAsPdfSharpIcon />*/}
            </Button>
          </span>
        ) : null}
      </DialogActions>
    </Dialog>
  );
};

DialogCreateAgreementPdf.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onAccept: PropTypes.func,
  hideAccept: PropTypes.bool
};

export default injectIntl(DialogCreateAgreementPdf);
